import { render, staticRenderFns } from "./AdresForm.vue?vue&type=template&id=6f1296f0&scoped=true"
import script from "./AdresForm.vue?vue&type=script&lang=ts"
export * from "./AdresForm.vue?vue&type=script&lang=ts"
import style0 from "./AdresForm.vue?vue&type=style&index=0&id=6f1296f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1296f0",
  null
  
)

export default component.exports